import { render } from "./Styleguide.vue?vue&type=template&id=f09a9414"
import script from "./Styleguide.vue?vue&type=script&lang=js"
export * from "./Styleguide.vue?vue&type=script&lang=js"
script.render = render

export default script